var map = {
	"./economie-finance.jpg": 99,
	"./immigration-laicite.jpg": 100,
	"./politique-internationale.jpg": 102,
	"./progres-humain.jpg": 103,
	"./securite-justice-defense.jpg": 104,
	"./urgence-democratique.jpg": 105,
	"./urgence-ecologique.jpg": 106,
	"./urgence-sociale.jpg": 107
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.jpg$
// module id = 194
// module chunks = 0